import { Routes } from '@angular/router';

import { ChillerFreeStShellComponent } from './chiller-free-st-shell/chiller-free-st-shell.component';
import { ChillerFreeStConfigurationComponent } from './pages/chiller-free-st-configuration/chiller-free-st-configuration.component';
import { ChillerFreeStDataSheetComponent } from './pages/chiller-free-st-data-sheet/chiller-free-st-data-sheet.component';

export const CHILLER_FREE_ST_ROUTES: Routes = [
  {
    path: '',
    component: ChillerFreeStShellComponent,
    children: [
      { path: '', redirectTo: 'configuration', pathMatch: 'full' },
      { path: 'configuration', component: ChillerFreeStConfigurationComponent },
      { path: 'data-sheet/:configurationId', component: ChillerFreeStDataSheetComponent },
    ],
  },
];
